// extracted by mini-css-extract-plugin
export default {"root":"organisation-area-content_root__62ZhE"};